import AdminLayout from "@/components/AdminLayout";
import SocialCampaign from "@/components/SocialCampaign";

export default function AdminSocial() {
  return (
    <AdminLayout>
      <div data-testid="admin-social-page">
        <SocialCampaign />
      </div>
    </AdminLayout>
  );
}
